export const MAX_CUSTOMERPO_LENGTH = 50;
export const MAX_SPECIAL_INSTRUCTIONS_LENGTH = 250;

export function customerPOValidator(value: string): string {
	if (!value?.trim()) {
		return "Customer PO is required.";
	}
	if (value.length > MAX_CUSTOMERPO_LENGTH) {
		return `Customer PO cannot exceed ${MAX_CUSTOMERPO_LENGTH} characters.`;
	}
	return "";
}

export function specialLoadInstructionsValidator(
	value: string | undefined,
): string {
	if (value && value.length > MAX_SPECIAL_INSTRUCTIONS_LENGTH) {
		return `Special Load Instructions cannot exceed ${MAX_SPECIAL_INSTRUCTIONS_LENGTH} characters.`;
	}
	return "";
}

export function trailerSizeRequired(value: string): string {
	if (value == undefined || value == null) {
		return "Trailer Size is required.";
	}
	return "";
}
